import styled from "styled-components"
import { TextSpan, UnderlinedTextButton } from "./Text"
import { useNavigate } from "react-router-dom"

const Footer = () => {
  const navigate = useNavigate()

  const handleClick = (props: string) => {
    navigate(`/policy/${props}`)
  }

  return (
    <FooterDiv id="footer">
      <Wrapper>
        <Left>
          <TextSpan
            fontSize={18}
            fontWeight="bold"
            color="var(--custom-platinum)"
          >
            앱티마이저
          </TextSpan>
          <TextSpan fontSize={14} color="var(--custom-platinum)">
            ((사업자 등록주소 삽입))
          </TextSpan>
          <TextSpan fontSize={13} color="var(--custom-platinum)">
            @copyright.{" "}
            <a
              href="https://www.naver.com"
              rel="noopener noreferrer"
              target="_blank"
            >
              앱티마이저
            </a>
          </TextSpan>
        </Left>
        <Right>
          <a title="submit suggestion" href="mailto:jhun1023@naver.com">
            개발 문의
          </a>
          <UnderlinedTextButton
            title="view privacy policy"
            fontSize={13}
            color="var(--custom-light-blue)"
            onClick={() => handleClick("privacy")}
          >
            서비스 이용약관
          </UnderlinedTextButton>
          <UnderlinedTextButton
            title="view service policy"
            fontSize={13}
            color="var(--custom-light-blue)"
            onClick={() => handleClick("privacy")}
          >
            개인정보 보호방침
          </UnderlinedTextButton>
        </Right>
      </Wrapper>
    </FooterDiv>
  )
}

export default Footer

const FooterDiv = styled.div`
  box-sizing: border-box;
  height: 200px;
  background-color: var(--custom-dark-brown);
  color: var(-custom-platinum);
  padding: 20px;
  pointer-events: auto;

  // position: sticky;
  // bottom: 0;
  // right: 0;
  // left: 0;

  @media ${({ theme }) => theme.device.pc} {
    padding: 20px 40px;
  }
`

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  a {
    font-size: 13px;
    cursor: pointer;
    text-decoration: underline;
    color: var(--custom-light-blue);

    &:hover {
      font-weight: bold;
    }
  }
`

const Left = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

const Right = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;
  gap: 10px;
  font-size: 12px;
  text-align: end;
`
